import _ from 'lodash';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import Fuse from 'fuse.js';
import * as actions from '../../actions/memberActions';
// import { Link } from 'react-router';
import ClubMemberList from '../../components/club/ClubMemberList';
import FontAwesome from 'react-fontawesome';
import PermissionLink from '../../components/common/PermissionLink';
// import Button from '../../components/common/Button';

class MemberList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.updateField = this.updateField.bind(this);
    this.deleteMember = this.deleteMember.bind(this);
    this.restoreMember = this.restoreMember.bind(this);
    this.filterMembers = this.filterMembers.bind(this);
    this.state = {
      memberFilter: "",
      showArchived: false,
    };
  }

  componentWillMount() {
    if(this.props.clubId && this.props.clubId != this.props.clubDetails.id ||
       this.props.clubId && this.props.memberList.length == 0) {
      this.props.actions.loadClubMembers(this.props.clubId);
    }
  }

  updateField(event) {
    let value = event.target.type == 'checkbox' ? event.target.checked : (event.target.value || '');
    this.setState({
      [event.target.name]: value,
    });
  }

  deleteMember(e, member) {
    if (!confirm('Bekreft at du ønsker å slette dette medlemmet')) {
      e.preventDefault();
      return false;
    }
    this.props.actions.deleteMember(member);
  }

  restoreMember(e, id) {
    this.props.actions.restoreMember(this.props.clubId, id);
  }

  filterMembers(e) {
    let memberFilter = e.target.value;
    this.setState({
      memberFilter: memberFilter
    });
  }

  render() {
    let filteredMemberList = this.props.memberList;
    if (!this.state.showArchived) {
      filteredMemberList = _.filter(filteredMemberList, (member) => {
        return !member.archived;
      });
    }
    if(this.state.memberFilter) {
      let searchMembers = new Fuse(this.props.memberList,{
        keys: [
          "first_name",
          "last_name",
          "address",
          "email",
          "phone_number"]
        });
      filteredMemberList = searchMembers.search(this.state.memberFilter);
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">

              <div className="page-header clearfix form-inline">
                <h2>
                  {'Medlemmer '}
                  <div className="pull-right">
                    <div className="input-group hidden-xs hidden-sm">
                      <span className="input-group-addon" id="basic-addon3">
                        <FontAwesome
                          name="search" />
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        onChange={this.filterMembers}
                        value={this.state.memberFilter}
                        />
                    </div>
                    {' '}
                    <PermissionLink
                      permission={this.props.clubDetails.permissions.write}
                      to={'/klubb/' + this.props.clubId + '/medlem/ny'}
                      className="btn btn-primary"
                      faName="plus">
                      <span className="hidden-xs">{' Nytt medlem'}</span>
                    </PermissionLink>
                    {' '}
                    <PermissionLink
                      permission={this.props.clubDetails.permissions.write}
                      to={'/klubb/' + this.props.clubId + '/importer-medlemmer'}
                      faName="cloud-upload"
                      className="btn btn-default">
                      <span className="hidden-xs">{' Importer'}</span>
                    </PermissionLink>
                    {' '}
                    <label className={classNames('btn btn-default btn-small',
                      {'active': this.state.showArchived})}>
                      <input type="checkbox"
                        name="showArchived"
                        className="hidden"
                        value={this.state.showArchived}
                        onChange={this.updateField}
                        checked={this.state.showArchived} />
                      <FontAwesome name={classNames({
                          'eye': !this.state.showArchived,
                          'eye-slash': this.state.showArchived
                        })} />
                        {' '}
                        <span className="hidden-xs">
                          {classNames({
                              'Vis': !this.state.showArchived,
                              'Skjul': this.state.showArchived
                            }) + ' arkiverte'}
                        </span>
                    </label>
                  </div>
                </h2>
              </div>
              <div className="">
                <div className="hidden-md hidden-lg hidden-xl">
                  <div className="input-group">
                    <span className="input-group-addon">
                      <FontAwesome
                        name="search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.filterMembers}
                      value={this.state.memberFilter}
                      />
                  </div>
                  <hr/>
                </div>
                <ClubMemberList
                  deleteMember={this.deleteMember}
                  restoreMember={this.restoreMember}
                  clubId={this.props.clubId}
                  members={filteredMemberList}
                  loading={this.props.loadingMembers} />
              </div>


          </div>
        </div>
      </div>
    );
  }
}

MemberList.propTypes = {
  actions: PropTypes.object.isRequired,
  memberList: PropTypes.array.isRequired,
  clubDetails: PropTypes.object.isRequired,
  clubDetailsUpdated: PropTypes.number,
  memeberDetailsUpdated: PropTypes.number,
  memberListUpdated: PropTypes.number,
  clubId: PropTypes.string.isRequired,
  loadingMembers: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    memberList: state.clubs.memberList,
    clubDetails: state.clubs.clubDetails,
    clubDetailsUpdated: state.clubs.clubDetailsUpdated,
    memeberDetailsUpdated: state.clubs.memeberDetailsUpdated,
    memberListUpdated: state.clubs.memberListUpdated,
    loadingMembers: state.clubs.loadingMembers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberList);



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/MemberList.js
 **/